import React from 'react'
import './FlipCard.css'
const FlipCard = (props) => {
    const cardClasses = ["flip-card"]
    cardClasses.push(props.active ? "active" : null);
    cardClasses.push(props.left ? "left" : null);
    // cardClasses.push(props.completed ? "found" : null);
    cardClasses.push(props.notmatched ? "notmatched" : null);
    const content = props.completed ? <div style={{ width: props.width, height: props.height }} className="found"></div> : (<div className={cardClasses.join(' ')} onClick={() => props.clicked(props.id, props.index)}
        style={{ width: props.width, height: props.height }}>
        <div className="flip-card-inner">
            <div className="flip-card-front">{props.front}</div>
            <div className="flip-card-back">
                <div className="contentbox">
                    <div id={props.id.startsWith('g') ? null : props.id} className={props.cssClass} data-icon={props.data}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    </div>)
    return content
}

export default FlipCard